var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_785_710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 21V16.7442C21 14.4638 19.8366 13.4031 18.2853 13.4031C17.0338 13.4031 16.473 14.1232 16.1603 14.629V13.5777H13.8023C13.8334 14.2741 13.8023 21 13.8023 21H16.1603V16.8546C16.1603 16.633 16.1755 16.4115 16.2384 16.2535C16.4084 15.8105 16.7963 15.3515 17.4474 15.3515C18.3012 15.3515 18.642 16.032 18.642 17.0292V21H21ZM11.3183 12.5646C12.1402 12.5646 12.6525 11.9945 12.6525 11.2815C12.6373 10.5534 12.1402 10 11.3334 10C10.5267 10 10 10.5534 10 11.2815C10 11.9937 10.5123 12.5646 11.3031 12.5646H11.3183ZM12.4969 21V13.5777H10.1396V21H12.4969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1C24.271 1 31 7.729 31 16C31 24.271 24.271 31 16 31C7.729 31 1 24.271 1 16C1 7.729 7.729 1 16 1ZM16 0C7.163 0 0 7.163 0 16C0 24.837 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.e88fb20fb2bdaca70f2c4e91532db4a6.svg";
export { ForwardRef as ReactComponent };